import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    processInstances: data?.processInstances?.map((item, index) => {
      return {
        id: index + 1,
        taskInstanceId: item?.taskInstanceId,
        workflowId: item?.workflowId,
        processingEntityId: item?.processingEntityConfiguration.processingEntityId,
        configType: item?.processingEntityConfiguration.configType,
        downloadEntityConfig: '',
        state: item?.workflowState,
        maker: item?.opsMakerUser?.username,
        value: item?.processingEntityConfiguration.value,
      }
    }),
  }
}

const getEntityConfigApprovals = (body: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getEntityConfigApprovals),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getEntityConfigApprovals }
